import React from 'react';
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Helmet} from "react-helmet";
import {useNavigate} from "react-router";
import {useCheckIfAdmin} from "../firebase/useCheckIfAdmin";
import {useFirebaseState} from "../firebase/firebaseContext";
import {UserProvider} from "./userContext";
import {UsersContent} from "./UsersContent";
import {EditUser} from "./EditUser";
import {UnauthorizedAccess} from "../app/UnauthorizedAccess";

export const Users = () => {
    const navigate = useNavigate();
    const {auth} = useFirebaseState();
    const isAdmin = useCheckIfAdmin();

    if (!auth || !auth.currentUser || !isAdmin) {
        return <UnauthorizedAccess requiredRole="administrator" />;
    }

    return (
        <UserProvider>
            <Container maxWidth="xl" sx={{ py: 3, px: {xs: 2, sm: 3}, width: "100%" }}>
                <Helmet>
                    <title>Brukeradministrasjon | Bekymringsmestring</title>
                </Helmet>

                <Box sx={{ mb: 3 }}>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate("/me")}
                        sx={{
                            mb: 2,
                            color: "text.secondary",
                            textTransform: "none",
                            fontWeight: 600,
                            borderRadius: 2,
                            minHeight: 44,
                            "&:hover": { color: "primary.main" },
                            "&:focus-visible": { outline: "2px solid #285238", outlineOffset: 2 },
                        }}
                    >
                        Tilbake til Min side
                    </Button>

                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{ fontWeight: 700, color: "primary.main", mb: 0.5 }}
                    >
                        Brukeradministrasjon
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Oversikt over registrerte brukere, roller og kontostatus. Trykk på en bruker for å endre rolle.
                    </Typography>
                </Box>

                <UsersContent />
                <EditUser />
            </Container>
        </UserProvider>
    );
};